// @flow

import React from 'react';
import { useIntl } from 'react-intl';
import { Link, Heading } from '@riseart/common';
import { FormBuilder } from '@riseart/form';
import { meta as META_ENUM } from 'Enum';
import { RegisterFormModel } from 'shared_models/forms/Register';
import { TermsSection } from 'shared_components/forms/common/TermsSection';

import {
  registerCls,
  registerFormCls,
  registerFormTitleCls,
} from 'shared_components/forms/register/Form.less';

const { ATTRIBUTE_CONTENT } = META_ENUM;

type Props = {
  loginPath: string,
  showLogin?: boolean,
  submitListener: Function,
};

/**
 * RegisterForm
 *
 */
export const RegisterForm = ({ loginPath, showLogin = true, submitListener }: Props) => {
  const intl = useIntl();
  const registerButtonText = intl.formatMessage({ id: 'forms.auth_form.register_button_text' });
  const loginButtonText =
    showLogin && loginPath && intl.formatMessage({ id: 'forms.auth_form.login_button_text' });

  return (
    <div className={registerCls}>
      <Heading tag="h3" level="5" align="center" className={registerFormTitleCls}>
        {intl.formatMessage({ id: 'forms.auth_form.sign_up_text' })}
      </Heading>
      <FormBuilder
        intl={intl}
        className={registerFormCls}
        settings={RegisterFormModel.settings}
        fields={RegisterFormModel.fields}
        submitActionLabel={registerButtonText}
        onSubmit={submitListener}
      />
      {showLogin && loginPath ? (
        <div>
          {intl.formatMessage({ id: 'forms.auth_form.register_text' })}
          {/* eslint-disable-line */}{' '}
          <Link to={loginPath} rel={ATTRIBUTE_CONTENT.NO_FOLLOW} title={loginButtonText}>
            {loginButtonText}
          </Link>
        </div>
      ) : null}
      <TermsSection translationValues={{ actionLabel: registerButtonText }} />
    </div>
  );
};
